import Backbone from 'backbone'
import PasteDestinationForm from './paste-destination-form'
import paste from './paste'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import _ from 'lodash'
import conductor from 'scoreboard/components/conductor'
import highlight from 'scoreboard/components/highlight'
import projects from 'scoreboard/projects/projects'
/**
 * View to let the user pick a destination for a standard (non-template) domain object (non-organization) copy or move.
 */
var CopyMovePasteDestinationForm = PasteDestinationForm.extend({

	initialize(options = {}) {
		// #48876 allow all object types to be moved between projects
		options.objectSelector = options.objectSelector || {}
		options.objectSelector.showProjectSelector = true
		options.objectSelector.projectId = projects.id

		options.primaryButtonLabel = i18n.get(`common.${options.mode}`)
		PasteDestinationForm.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		PasteDestinationForm.prototype.render.apply(this, arguments)
		// display "copy & edit" button #13874
		if (this.options.mode === 'copy') {
			this.$('.button-secondary').removeClass('is-not-displayed')
		}
	},

	title: function () {
		var key = 'common.' + this.options.mode + '.to'
		return i18n.get(key, '<q>' + _.escape(this.options.object.label) + '</q>')
	},

	test: function() {
		if (this.options.domainType == 'scorecard-item' &&
			this.options.object.type == 'root') {
			let selectedOrg = _.result(this.objectSelector, 'selectedOrg')
			// if the selected org already has a scorecard
			if (_.get(selectedOrg, 'scorecards')) {
				return i18n.get('scorecards.error.scorecardRootAlreadyExists')
			}

			// #32832 can't move/copy a scorecard to a copy org, even if it's empty
			if (_.get(selectedOrg, 'templateId')) {
				let copyLabel = highlight(selectedOrg.label)
				let rollupTreeGroupLabel = highlight(
					this.objectSelector.orgGardener.tree.get(selectedOrg.templateId).label)

				return i18n.get('' +
					'scorecards.error.destinationIsTemplateCopy',
					copyLabel, rollupTreeGroupLabel
				)
			}
		} else if (this.options.domainType === 'dataset') {
			if (!_.result(this.objectSelector, 'selectedOrg')) {
				return i18n.get('common.organization.select')
			}
		}
		return PasteDestinationForm.prototype.test.apply(this, arguments)
	},

	submit: function (opts = {}) {
		var options = {
			url: this.options.url,
			mode: this.options.mode,
			section: this.options.section,
			domainType: this.options.domainType,
			id: this.options.object.id,
			// the ID of the org the domain object is moving to
			orgId: _.get(this.getOrg(), 'id'),
			// the ID of the org the object used to belong to
			oldOrgId: globals.orgId,
			// #13874 edit will be true if form was submitted using "copy & edit"
			edit: opts.edit,
			error: this.formView.error.bind(this.formView)
		}

		// Add in parentId and index (if necessary)
		_.extend(options, this.addPosition())

		if (!options.parentId && !options.orgId) {
			// if no parent or org was chosen and the user chose confirm right
			// away then we are moving to the org the item is already in
			options.orgId = globals.orgId
		}

		paste(options, function(ids) {
			// close the dialog first so the trees there don't try to listen
			// to any resulting events triggered by the paste
			this.trigger('done')
			this._onPaste(options, ids)
		}.bind(this))
	},

	/**
	 * "Copy & Edit" Button
	 */
	submitSecondary: function () {
		this.submit({edit: true})
	},

	_onPaste(options, ids) {
		Backbone.trigger(options.mode + ':domain-object', options, ids)

		// trigger change:root if appropriate.  #12864 this event is only
		// for moves!
		if (options.mode === 'move') {
			var orgTree = this.objectSelector.orgGardener.tree
			var orgNode = orgTree.get(this.options.object.organizationId)
			var rootMoved = orgNode &&
				orgNode[this.options.section] == this.options.object.id
			if (rootMoved) {
				Backbone.trigger('change:root', options, ids)
			}
		}

		// #13874 navigate to new item for editing if "copy & edit" was selected
		if (options.mode === 'copy' && options.edit) {
			let id = ids[options.id]
			let url = conductor.editUrl(options.section, id)
			if (this._isSlide()) {
				url = `briefings/${options.parentId}/slides/${id}/edit`
			}
			conductor.navigate(url, {trigger: true})
			// when navigating to the new item the briefings section, the change
			// was not reflected in the label on projects/organization menu
			if (options.section === 'briefings') {
				if (options.orgId != options.oldOrgId) {
					globals.orgId = options.orgId
				}
			}
		}
	}
})

export default CopyMovePasteDestinationForm

CopyMovePasteDestinationForm.__filename__ = 'components/paste/copy-move-destination-form.js'
